import React, { useState } from "react";
import { Box } from "@mui/material";
import ChatPanel from "../ChatPanel/ChatPanel";
import SourcesPanel from "../SourcesPanel/SourcesPanel";
import TallyFormPanel from "../TallyFormPanel/TallyFormPanel";
import { ChatProvider } from "../../contexts/ChatContext";
import { SourceProvider } from "../../contexts/SourcesContext";

const MateriomAIContainer: React.FC<{
  input: string;
  setInput: (val: string) => void;
}> = ({ input, setInput }) => {
  // State to control the expansion of the sources panel
  const [isPanelExpanded, setIsPanelExpanded] = useState(false);

  return (
    <SourceProvider>
      <Box
        sx={{
          display: "flex",
          height: "auto",
          overflow: "hidden",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {/* Sources Panel Container (includes TallyFormPanel) */}
        <Box
          sx={{
            width: {
              lg: isPanelExpanded ? "60%" : "45%",
              xl: isPanelExpanded ? "60%" : "45%",
            },
            minWidth: {
              sm: "300px",
              md: "350px",
              lg: "400px",
              xl: "450px",
            },
            display: { xs: "none", sm: "flex" },
            flexDirection: "column",
            mx: 2,
            gap: 2,
            height: { xs: "100vh", sm: "85vh" },
            transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)",
          }}
        >
          <SourcesPanel
            isPanelExpanded={isPanelExpanded}
            setIsPanelExpanded={setIsPanelExpanded}
          />
          <TallyFormPanel />
        </Box>
        {/* Chat Panel Container */}
        <Box
          sx={{
            flex: { xs: 3, lg: isPanelExpanded ? 2 : 3 }, // Reduce when expanded only on lg+
            minWidth: {
              xs: "100%", // Take full width on extra small screens
              sm: "300px", // More reasonable min-width for small screens
              md: "350px", // Increased min-width for medium screens
              lg: "400px", // Increased min-width for large screens
              xl: "450px", // Increased min-width for extra large screens
            },
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)",
          }}
        >
          <ChatProvider>
            <ChatPanel input={input} setInput={setInput} />
          </ChatProvider>
        </Box>
      </Box>
    </SourceProvider>
  );
};

export default MateriomAIContainer;
